/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also inspect dates, percentages, leading zeros in identifiers and hidden sheets. If the workbook depends on external connections, refresh behavior or a data model, test those requirements separately. Preserving a file part is different from executing the workflow behind it.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还要检查日期、百分比、编号前导零和隐藏工作表。依赖外部连接、数据刷新或数据模型的工作簿，需要单独测试这些需求。保留文件中的某个部件，并不等于能够执行其背后的完整流程。`)
};

/**
* | output |
* | --- |
* | "Also inspect dates, percentages, leading zeros in identifiers and hidden sheets. If the workbook depends on external connections, refresh behavior or a data ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.4.paragraphs.1" }